export const DAY_MS = 86400000;
export const iso = (d) => d.toLocaleDateString("en-CA");
export const parse = (s) => new Date(`${s}T00:00:00`);
export const addDays = (s, n) => iso(new Date(parse(s).getTime() + n * DAY_MS));
export const daysBetween = (a, b) => Math.round((parse(b) - parse(a)) / DAY_MS);
export const today = () => iso(new Date());
/** Range start that puts `t` in the middle column of an `n`-day view (14 → 6 days before, 7 after). */
export const centredStart = (t, n) => addDays(t, -Math.floor((n - 1) / 2));
export const isWeekend = (s) => [0, 6].includes(parse(s).getDay());
export const dayName = (s) => parse(s).toLocaleDateString("en-US", { weekday: "short" }).toUpperCase();
export const fmtShort = (s) => parse(s).toLocaleDateString("en-US", { month: "short", day: "numeric" });
export const fmtLong = (s) => parse(s).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
export const rangeLabel = (from, to) => {
  const a = parse(from), b = parse(to);
  const sameYear = a.getFullYear() === b.getFullYear();
  return `${a.toLocaleDateString("en-US", { month: "short", day: "numeric" })} — ${b.toLocaleDateString("en-US", { month: "short", day: "numeric", ...(sameYear ? {} : { year: "numeric" }) })}, ${b.getFullYear()}`;
};

export const STATUS_DOT = { vacant_clean: "#14C48E", available: "#14C48E", occupied: "#DC2626", reserved: "#014751", vacant_dirty: "#F59E0B", dirty: "#F59E0B", blocked: "#97A6A9", out_of_order: "#97A6A9", out_of_service: "#97A6A9", maintenance: "#F59E0B" };

export const LEGEND = [
  { key: "occupied", label: "Checked In", style: { background: "#37F4B5" } },
  { key: "reserved", label: "Reserved", style: { background: "#E6FEFF", border: "1.5px dashed #014751" } },
  { key: "blocked", label: "Blocked", style: { background: "#FEF3C7", borderTop: "3px solid #F59E0B" } },
  { key: "out_of_order", label: "Out of Order", style: { background: "#FEE2E2", borderTop: "3px solid #DC2626" } },
  { key: "vacant_dirty", label: "Vacant / Dirty", style: { background: "repeating-linear-gradient(-45deg,#EEF1F4,#EEF1F4 3px,#F4F6F8 3px,#F4F6F8 6px)", border: "1px solid #D5E6E8" } },
  { key: "vacant_clean", label: "Vacant / Clean", style: { background: "#FFFFFF", border: "1px solid #D5E6E8" } },
];

/** Pixel geometry of a segment inside a row. Occupied/reserved bars run mid-cell to mid-cell (check-in noon → check-out noon). */
export function barGeometry(seg, dates, col, roomCol) {
  const from = dates[0], to = dates[dates.length - 1];
  const startIdx = Math.max(0, daysBetween(from, seg.date_from));
  const endIdx = Math.min(dates.length - 1, daysBetween(from, seg.date_to));
  if (endIdx < 0 || startIdx > dates.length - 1) return null;
  const halfCell = seg.type === "occupied" || seg.type === "reserved";
  const clippedStart = seg.check_in ? seg.check_in < from : false;
  const clippedEnd = seg.check_out ? seg.check_out > to : false;
  let x0 = startIdx * col, x1 = (endIdx + 1) * col;
  if (halfCell) {
    x0 = clippedStart ? startIdx * col : (startIdx + 0.5) * col;
    x1 = clippedEnd ? (endIdx + 1) * col : (endIdx + 0.5) * col;
  }
  return { left: roomCol + x0, width: Math.max(x1 - x0, col * 0.45) };
}
